export const correctStatus = {
    waiting: "Em espera",
    production: "Em produção",
    delivery: "Saiu para entrega",
    finished: "Finalizado",
    canceled: "Cancelado",
    cancellation_requested: "Cancelamento solicitado"
}